import config from "../../../shared/config/config";
import axiosAdmin from "../../../shared/utils/axiosAdmin";
import {
  WhiteLabelRequestDTO,
  WhiteLabelResetResponseDTO,
  WhiteLabelResponseDTO,
} from "../../../types/adminWhiteLabel";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminWhiteLabelApi {
  setWhiteLabel(
    whiteLabelOptions: WhiteLabelRequestDTO
  ): Promise<WhiteLabelResponseDTO>;
  getWhiteLabel(): Promise<WhiteLabelResponseDTO>;
  resetWhiteLabel(): Promise<WhiteLabelResetResponseDTO>;
}

class AdminWhiteLabelServerApi implements AdminWhiteLabelApi {
  async setWhiteLabel(
    whiteLabelRequest: WhiteLabelRequestDTO
  ): Promise<WhiteLabelResponseDTO> {
    const formData = new FormData();
    formData.append("loginBiImg", whiteLabelRequest.loginBiImg ?? null);
    formData.append("loginSubImg", whiteLabelRequest.loginSubImg ?? null);
    formData.append("mainBiImg", whiteLabelRequest.mainBiImg ?? null);
    formData.append("emailBiImg", whiteLabelRequest.emailBiImg ?? null);
    formData.append("clientBiImg", whiteLabelRequest.clientBiImg ?? null);
    formData.append("serviceBiImg", whiteLabelRequest.serviceBiImg ?? null);

    const requestDto = {
      mailSubjectPrefix: whiteLabelRequest.mailSubjectPrefix ?? "",
      siteName: whiteLabelRequest.siteName ?? "",
      useAdminPageLoginBiImg: whiteLabelRequest.useAdminPageLoginBiImg,
      useAdminPageLoginSubImg: whiteLabelRequest.useAdminPageLoginSubImg,
    };

    formData.append(
      "requestDTO",
      new Blob([JSON.stringify(requestDto)], {
        type: "application/json",
      })
    );

    const resp = await axiosAdmin.post<WhiteLabelResponseDTO>(
      `${GATEWAY_URL}/wapi/admins/config/whitelabel`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return Promise.resolve(resp.data);
  }

  async getWhiteLabel(): Promise<WhiteLabelResponseDTO> {
    const resp = await axiosAdmin.get<WhiteLabelResponseDTO>(
      `${GATEWAY_URL}/wapi/admins/config/whitelabel`
    );
    return Promise.resolve(resp.data);
  }

  async resetWhiteLabel(): Promise<WhiteLabelResetResponseDTO> {
    const resp = await axiosAdmin.post<WhiteLabelResetResponseDTO>(
      `${GATEWAY_URL}/wapi/admins/config/whitelabel/reset`
    );
    return Promise.resolve(resp.data);
  }
}
const adminWhiteLabelApi: AdminWhiteLabelApi = new AdminWhiteLabelServerApi();
export default adminWhiteLabelApi;
